module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('main-layout', {
    attrs: {
      "ResizeCallback": _vm.resize
    }
  }, [_c('div', {
    staticClass: "reportContainer",
    style: ({
      height: this.reportHeight + 'px'
    })
  }, [_c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('iframe', {
    ref: "report_iframe",
    attrs: {
      "id": "report_iframe",
      "src": _vm.url,
      "frameborder": "0",
      "allowtransparency": "true",
      "marginheight": "0",
      "marginwidth": "0",
      "scrolling": "no"
    },
    on: {
      "load": _vm.iframe_loaded
    }
  }), _vm._v(" "), _c('div', {
    ref: "hiddenDiv",
    staticStyle: {
      "display": "none"
    }
  })], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1e1b49c6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Report.vue
// module id = 473
// module chunks = 2